import { Pagination, PaginationProps } from 'react-admin';
import React from 'react';

// Add label is passed although it not supported by Pagination
export default ({ addLabel, ...props }: PaginationProps & { addLabel?: any }) => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
);
